// Show rooms
export const SHOWROOM_NAMES = {
  BARSHA: 'Barsha',
  DHECOMM: 'Online',
  DIBBA: 'Dibba',
  FUJ: 'Fujeirah',
  ICT: 'Ict',
  JIMIM: 'Jimi Mall',
  RAK_B2C: 'Rak B2C',
  REEMM: 'Reem Mall',
  SHJHOME: 'Sharjah',
  // Oman Show rooms
  DANDIROM: 'Oman Online',
  SOHR: 'Sohar',
  SUR: 'Sur',
  BARKA: 'Barka',
  NIZWA: 'Nizwa',
  ALKWH: 'ALKWH',
  MBLB2C: 'MBLB2C',
  ALKHWR: 'al khair',
  // Bahrain Show rooms
  DANDIRBH: 'Bahrain Online',
  SLMBD: 'Salmabad',
  // Qatar Show rooms
  DANDIRQR: 'Qatar Online',
  SALWA: 'Salwa',
};

export const STORES = {
  AE: {
    BARSHA: 'Barsha',
    DHECOMM: 'Online',
    DIBBA: 'Dibba',
    FUJ: 'Fujeirah',
    ICT: 'Ict',
    JIMIM: 'Jimi Mall',
    RAK_B2C: 'Rak B2C',
    REEMM: 'Reem Mall',
    SHJHOME: 'Sharjah',
  },
  OM: {
    // Oman Show rooms
    DANDIROM: 'Oman Online',
    SOHR: 'Sohar',
    SUR: 'Sur',
    BARKA: 'Barka',
    NIZWA: 'Nizwa',
    ALKWH: 'ALKWH',
    MBLB2C: 'MBLB2C',
    ALKHWR: 'al khair',
  },

  BH: {
    // Bahrain Show rooms
    DANDIRBH: 'Bahrain Online',
    SLMBD: 'Salmabad',
  },
  QA: {
    // Qatar Show rooms
    DANDIRQR: 'Qatar Online',
    SALWA: 'Salwa',
  },
};
